import { LocationsApi } from '@itsrever/returns-api-types'
import { toCountries } from './dto'

const locationsApi = new LocationsApi()

async function getCountries(signal?: AbortSignal) {
  const result = await locationsApi.countries(
    {
      ecommerceID: 'random'
    },
    { signal }
  )
  return toCountries(result.data)
}

export default { getCountries }
